import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Text from "./text"
import Space from "./space"
import Divider from "./divider"
import Link from "./link"

type Props = {}

const Categories: React.FC<Props> = () => {
  const {
    allContentfulSortableContent: { nodes },
  } = useStaticQuery(graphql`
    query CategoriesQuery {
      allContentfulSortableContent(filter: { title: { eq: "カテゴリ" } }) {
        nodes {
          categories {
            name
            slug
          }
        }
      }
    }
  `)

  return (
    <div>
      <Text fontSize="2xl" lgFontSize="3xl" fontBold={true}>
        カテゴリ
      </Text>
      <Space sizeY="6" lgSizeY="8" />
      {nodes[0].categories.map(
        (category: { name: string | null; slug: string | null }) => {
          return (
            <Link key={category.slug} to={`/column/category/${category.slug}/`}>
              <Text classes="py-2.5">{category.name}</Text>
              <Divider color="gray-800 opacity-20" />
            </Link>
          )
        }
      )}
    </div>
  )
}

export default Categories
